import React from "react";
import img from "../../images/showcase-img.png";
import TurnedInNotIcon from "@mui/icons-material/TurnedInNot";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";

export default function ShowCaseCard() {
  return (
    <>
      <Box
        className="showCase-div1"
        sx={{ display: "flex", justifyContent: "space-between", p: 2 }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box>
            <img src={img} className="showCase-img" />
          </Box>
          <Box className="showCase-div2">
            <Typography
              sx={{ fontSize: "18px", fontWeight: 700, marginTop: "5%" }}
            >
              UI/UX Designer
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                marginTop: "5%",
              }}
            >
              AckrolixInnovation
            </Typography>
            <Typography   sx={{
                fontSize: "14px",
                fontWeight: 400,
                marginTop: "5%",
              }}>
              Sector 44, Gurugram
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <TurnedInNotIcon />
          </Box>
          <Box >
            <a
              href="#"
              style={{
                textDecoration: "none",
                fontSize: "11px",
                color: "#3665D0",
                fontWeight: 500,
                fontFamily:'Inter',
                mb:1
              }}
            >
              View Details
            </a>
              <KeyboardArrowRightIcon />
          </Box>
        </Box>
      </Box>
    </>
  );
}
